const lightTheme = {
  colors: {
    bg: "#e0c3fc",
    bgAlpha: "#e0c3fc70",
    text: "#231942",
    highlight: "#7209b7",
    accent: "#f72585",
    primary: "#757bc8",
    secondary: "#bbadff",
    success: "#0091ad",
    error: "#b7094c",
  },
};

const darkTheme = {
  colors: {
    bg: "#231942",
    bgAlpha: "#23194270",
    text: "#e0c3fc",
    highlight: "#7209b7",
    accent: "#f72585",
    primary: "#bbadff",
    secondary: "#757bc8",
    success: "#0091ad",
    error: "#b7094c",
  },
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
